import { apiClient } from './apiClient';

const createGiveaway = async (payload) => {
  return await apiClient.post('/dashboard/giveaway', payload);
};

const fetchGiveaways = async (payload) => {
  return await apiClient.get('/dashboard/giveaway', payload);
};

const updateGiveaway = async (id, payload) => {
  return await apiClient.patch(`/dashboard/giveaway/${id}`, payload);
};

const fetchParticipiants = async (payload) => {
  return await apiClient.get('/dashboard/giveaway/participants', payload);
};

const pickWinner = async (payload) => {
  return await apiClient.post('/dashboard/giveaway/pick', payload);
};

const rerollWinner = async (payload) => {
  return await apiClient.post('/dashboard/giveaway/reroll', payload);
};

export const giveawayApi = {
  createGiveaway,
  fetchGiveaways,
  updateGiveaway,
  fetchParticipiants,
  pickWinner,
  rerollWinner
};
